import React from "react";
import { observer, inject } from "mobx-react";
import ObVitalsStore from "./ObVitalsStore";
import Loader from "../../shared/Loader/Loader";
import Grid from "../../shared/Grid/Grid";
import config from "../../config";
import _ from "lodash";
import Widget from "../Widget";

class ObVitalsExpanded extends Widget {
  constructor(props) {
    super(props);
    const username = sessionStorage.username;
    const asmpid = this.props?.summaryStore?.asmpid;
    this.store = new ObVitalsStore();
    this.store.fetchObVitals({
      username,
      asmpid,
    });
  }

  render() {
    return (
      <div className="ob-vitals component">
        {this.store.loading ? (
          <Loader />
        ) : _.get(this.store.vitals, "groups", []).length ? (
          <Grid
            labs={this.store.vitals}
            reverse={config.vitals.reverseChron}
            ob={true}
            history={this.props.history}
          />
        ) : (
          <div className="no-data">No Vitals</div>
        )}
      </div>
    );
  }
}

export default inject("store")(observer(ObVitalsExpanded));
